// Migration placeholders — archived stand-in accounts the Supabase load created
// for drivers/stores deleted from Firestore long ago (users.placeholder, see
// supabase/migrations/0020_legacy_tracking.sql). They exist only so old
// orders, transactions and stock rows keep a valid foreign key; they are not
// accounts anyone manages, logs into, or should ever see.
//
// The web client drops them at the source (the users listener in AppContext),
// so every screen treats them exactly like an account that no longer exists:
// pickers and rosters skip them, holder chips disappear, their stock rows are
// "deleted-account" rows (ignored by the product picker; listed only on the
// Inventory Tracker's reconciliation panel), and an old order names no driver.
// Nothing is deleted — the rows stay in Postgres for history and foreign keys.
export interface PlaceholderFlagged {
    placeholder?: boolean | null;
}

export const isPlaceholderUserRow = (r: PlaceholderFlagged): boolean => r.placeholder === true;

export const dropPlaceholderUsers = <T extends PlaceholderFlagged>(rows: T[]): T[] =>
    rows.filter((r) => !isPlaceholderUserRow(r));
